import React from 'react';
import {
    Expander,
    ExpanderTheme,
    ExpanderButtonStyle,
    ExpanderBorderRoundingStyle,
    Panel,
    PanelTheme,
    PanelBorderRadius,
    PanelBorderStyle,
    renderCustomCountExpanderHeader,
} from '@apply/components';
import { isMobileScreen } from '@apply/ui';
import '../../../../scss/_homepanels.scss';
import { DashboardLoansToClose } from '@apply/api/src/api/ApplyApi';

interface LoansApprovedToCloseParameters {
    loansReadyToClose: DashboardLoansToClose[][];
}

export const LoansApprovedToClosePanel: React.FC<LoansApprovedToCloseParameters> = ({ loansReadyToClose }) => {
    return (
        <div>
            <Expander
                header={renderCustomCountExpanderHeader(loansReadyToClose.length, 'Loans Approved to Close')}
                theme={ExpanderTheme.Red}
                buttonStyle={ExpanderButtonStyle.Rounded}
                borderRoundingStyle={ExpanderBorderRoundingStyle.Rounded}
            >
                {loansReadyToClose.map((loan, index) => {
                    return (
                        <div
                            key={index}
                            style={{ marginLeft: '20px', marginRight: '20px' }}
                        >
                            <Panel
                                key={index}
                                padding={10}
                                theme={PanelTheme.White}
                                borderRadius={PanelBorderRadius.Small}
                                borderStyle={PanelBorderStyle.Solid}
                            >
                                <div className='panelContent loansApprovedToClose'>
                                    <div
                                        key={index}
                                        className='address'
                                    >
                                        {loan.map((address, addressIndex) =>
                                            isMobileScreen() ? (
                                                <React.Fragment key={addressIndex}>
                                                    <div className='addressItem'>{address.street}</div>
                                                    <div className='addressItem'>{address.city}</div>
                                                </React.Fragment>
                                            ) : (
                                                <div key={addressIndex} className='addressItem'>{`${address.street}, ${address.city}`}</div>
                                            )
                                        )}
                                    </div>
                                    <div className='contact'>Contact BFI to close</div>
                                </div>
                            </Panel>
                        </div>
                    );
                })}
            </Expander>
        </div>
    );
};
